const kzs = window.kzs;
const $ = kzs.$;

import style from "./suggestion.css";

export class AeonSuggestion {
  run(): void {
    // ポップアップの埋め込み
    const $popup = $(`
      <div class="kzPopupUnderlay">
        <div class="kzPopup">
          <div class="kzPanel">
	          <div class="kzClose"></div>
            <div class="kzDesc">
	            <p>以下のカードの</p>
	            <p>お申込みを忘れていませんか？</p>
	          </div>
	          <div class="kzCard">イオンカード（ミニオンズ）</div>
	          <img src="https://www.aeon.co.jp/-/media/AeonCard/common/cardface/card_141_v.png?la=ja-JP&hash=6011E0F4F4D29A5755398E315CAD0173" class="kzImg">
	          <a href="https://www.aeon.co.jp/application/minions/" class="kzBtn">お申込みはこちら</a>
            <a href="https://www.aeon.co.jp/card/lineup/minions/" class="kzConfirm">再度特典を確認する</a>
          </div>
        </div>
      </div>
    `);
    $popup.find(".kzPopup").on("click", (e) => {
      const cls = $(e.target).attr("class");
      return cls == "kzBtn" || cls == "kzConfirm";
    });
    $popup.prependTo("body");

    // 閉じるボタンのclickイベント登録
    $("body .kzClose,body .kzPopupUnderlay").on("click", (e) => {
      const cls = $(e.target).attr("class");
      if (cls == "kzConfirm") {
        // 「再度特典を確認する」をクリックした時はポップアップを閉じるのみ（次回再訪時に再度ポップアップを表示する）
        this.closePopup();
      } else {
        // その他は次回以降ポップアップは表示しない
        this.countupSuggestion();
        this.closePopup();
      }
    });

    // スタイルシート適用
    style.use();

    // 再訪促進のポップアップ表示
    $("body").addClass("showPopup");
  }

  countupSuggestion(): void {
    // ユーザ属性中の再訪促進回数をカウントアップする
    const suggestion = kzs.current.userData["suggestion"] + 1;
    const data = {
      url: "https://www.aeon.co.jp/application/minions/",
      suggestion: suggestion,
    };
    kzs("setUserData", data, () => {
      kzs.console.log(`userData - suggestion: ${suggestion} is set.`);
    });
  }

  closePopup(): void {
    // ポップアップを閉じる
    $("body").removeClass("showPopup");
    $(".kzPopupUnderlay").removeAttr("style");
  }
}
